const spannifyLastWord = (string, className) => {
  const textAsArray = string.split(" ");
  const lastWord = textAsArray.pop();

  return `${textAsArray.join(" ")} <span class=${className}>${lastWord}</span>`;
};

export default spannifyLastWord;
